import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './dtos/create-vehicle-insurance-claim.dto';
export * from './dtos/update-vehicle-insurance-claim.dto';
export * from './dtos/vehicle-insurance-claim-list.dto';
export * from './dtos/vehicle-insurance-claim-record.dto';
export * from './dtos/vehicle-insurance-claim-search.dto';
export * from './dtos/vehicle-insurance-claims-stats.dto';

export * from './enums/vehicle-insurance-claim-record-category.enum';
export * from './enums/vehicle-insurance-claim-status.enum';

export * from './types/vehicle-insurance-claims-filters';

export * from './validators/schemas/create-vehicle-insurance-claim.schema';
export * from './validators/schemas/update-vehicle-insurance-claim.schema';

export const vehicleInsuranceClaimValidators = { canCreateOrUpdate };
